import moment from "moment";

function getSelectedDate(queryDate) {
    let date = moment();
    if (queryDate) {
        date = moment(queryDate);
    }

    let fromDate = date.startOf('month').format('YYYY-MM-DD');
    let toDate = moment().subtract(1, 'days').format('YYYY-MM-DD');

    if (moment(toDate).isBefore(fromDate)) {
        [fromDate, toDate] = [toDate, fromDate];
    }


    return {
        fromDate: moment().format('YYYY-MM-DD') == moment().startOf('month').format('YYYY-MM-DD') ? date : fromDate,
        toDate: moment().format('YYYY-MM-DD') == moment().startOf('month').format('YYYY-MM-DD') ? date : toDate
    }
}

export default getSelectedDate;